import Vue from 'vue'
import App from './App.vue'
import router from './router'

// vue-mq
import VueMq from 'vue-mq';
Vue.use(VueMq, {
  breakpoints: {
    mobile: 768,
    desktop: Infinity
  },
  defaultBreakpoint: 'desktop'
});

// Material design icons
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

// Font Awesome 5 as CSS
import '@fortawesome/fontawesome-free/css/all.css';

Vue.config.productionTip = false

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Buefy)

// Install App plugin
import InstallAppPlugin from '@/plugin/InstallAppPlugin';
Vue.use(InstallAppPlugin);

import { FilterUtil } from './util/FilterUtil';
const filterUtil = new FilterUtil();
Vue.filter('formatDeviceType', filterUtil.formatDeviceType);
Vue.filter('tsToString', filterUtil.tsToString);
Vue.filter('tsToAgo', filterUtil.tsToAgo);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
